/** The references object of all modules needed for components initialization */
var references = {
    'customerservice' : require('_core_ext/pages/content'),
    'createreturn' : require('_core_ext/pages/createreturn'),
};

module.exports = {
    'references' : references
};
